import type { DictShape } from './en';

export const ru: DictShape = {
  // navigation rail
  nav_home: 'Главная',
  nav_all_pages: 'Все страницы',
  nav_categories: 'Категории',
  nav_recent_changes: 'Свежие правки',
  nav_reports: 'Отчёты',
  nav_map: 'Карта мира',
  nav_random: 'Случайная страница',
  nav_relations: 'Связи',
  nav_aria_label: 'Навигация',
  nav_create_page: 'Создать страницу',
  // sidebar / page list
  sidebar_aria_label: 'Страницы',
  sidebar_nav_label: 'Список страниц',
  // locale switcher
  lang_switcher_label: 'Язык интерфейса',
  // top bar / search
  search_placeholder: 'Поиск',
  search_no_results: 'Нет результатов.',
  search_empty: 'Ничего не найдено.',
  search_pages_one: '1 страница',
  search_pages_many: '{{count}} страниц',
  search_loading: 'Загрузка',
  search_searching: 'Поиск',
  // auth / account panel
  auth_login: 'Войти',
  auth_logout: 'Выйти',
  auth_register: 'Регистрация',
  auth_change_password: 'Пароль',
  auth_moderation: 'Модерация',
  auth_panel_label: 'Участник',
  auth_login_to_propose: 'Войдите, чтобы предложить правку.',
  auth_propose_edit: 'Предложить правку',
  auth_pending_count: '{{count}} ожидает модерации',
  auth_contributor_access: 'Contributor access',
  auth_account_security: 'Account security',
  auth_email: 'Почта',
  auth_password_label: 'Пароль',
  auth_logging_in: 'Входим',
  auth_passwords_mismatch: 'Пароли не совпадают.',
  auth_confirm_password: 'Повторите пароль',
  auth_creating_account: 'Создаем',
  auth_create_account: 'Создать аккаунт',
  auth_already_have_account: 'Уже есть вход',
  auth_error_login: 'Не удалось войти.',
  auth_error_register: 'Не удалось зарегистрироваться.',
  auth_contributor_required: 'Нужен вход участника.',
  auth_password_account_hint: 'Пароль можно изменить только для текущего аккаунта.',
  auth_current_password: 'Текущий пароль',
  auth_new_password: 'Новый пароль',
  auth_saving: 'Сохраняем',
  auth_save: 'Сохранить',
  auth_cancel: 'Отмена',
  auth_new_passwords_mismatch: 'Новый пароль и подтверждение не совпадают.',
  auth_password_changed: 'Пароль изменен.',
  auth_error_change_password: 'Не удалось изменить пароль.',
  // graph / relations panel
  graph_relations_title: 'Связи',
  graph_hide_btn: 'Скрыть связи',
  graph_svg_label: 'Граф страниц',
  graph_backlinks: 'Обратные ссылки',
  graph_loading: 'Загрузка связей.',
  graph_empty: 'Пока нет.',
  // table of contents
  toc_title: 'Содержание',
  toc_show: '[показать]',
  toc_hide: '[скрыть]',
  // reader / article
  reader_loading: 'Загрузка…',
  reader_not_found: 'Страница не найдена',
  reader_stub: 'Это заготовка страницы.',
  reader_read: 'Читать',
  reader_edit: 'Править',
  reader_history: 'История',
  reader_propose_missing: 'Предложить страницу',
  reader_home: 'Главная',
  reader_breadcrumbs_label: 'Хлебные крошки',
  reader_page_loading: 'Загрузка страницы.',
  reader_redirected_from: 'Перенаправлено с',
  reader_redirect_loop: 'Эта страница образует цикл перенаправлений.',
  reader_page_empty: 'Эта страница пока пуста.',
  reader_categories_label: 'Категории:',
  reader_published_prefix: 'Опубликовано',
  reader_page_stub: 'Заготовка',
  reader_missing_lang: 'Страница не найдена на {{lang}}.',
  reader_propose_translation: 'Предложить перевод',
  reader_no_pages: 'Нет опубликованных страниц.',
  reader_page_missing: 'Страницы «{{slug}}» пока нет.',
  reader_relevant_label: 'Связанные страницы',
  reader_relevant_page: 'Страница',
  reader_relevant_link: 'Связь',
  reader_relevant_mutual: 'взаимная',
  reader_relevant_inbound: 'ссылается сюда',
  reader_relevant_outbound: 'ссылка',
  reader_other_langs_label: 'Другие языки',
  reader_other_langs: 'Другие языки:',
  reader_info: 'Информация',
  // page information panel
  page_info_title: 'Информация о странице',
  page_info_revisions: 'Правки',
  page_info_contributors: 'Участники',
  page_info_inbound: 'Входящие ссылки',
  page_info_outbound: 'Исходящие ссылки',
  page_info_categories: 'Категории',
  page_info_created: 'Создана',
  page_info_updated: 'Обновлена',
  page_info_current_revision: 'Текущая версия',
  page_info_translations: 'Переводы',
  page_info_loading: 'Загрузка информации.',
  page_info_error: 'Не удалось загрузить информацию о странице.',
  page_info_back: '← Читать',
  page_info_none: '—',
  // propose / edit
  propose_new_label: 'New proposal',
  propose_edit_label: 'Edit proposal',
  propose_new_title: 'Новая страница',
  propose_edit_title: 'Правка: {{title}}',
  propose_submit: 'Отправить предложение',
  propose_cancel: 'Отмена',
  propose_login_required: 'Войдите, чтобы предложить страницу.',
  propose_contributor_required: 'Нужен вход участника.',
  propose_hint: 'Правки сохраняются как предложения и ждут модерации.',
  propose_page_loading: 'Загрузка страницы для правки.',
  propose_page_not_found: 'Страница для правки не найдена.',
  propose_title_label: 'Название',
  propose_categories_label: 'Категории',
  propose_categories_placeholder: 'Через запятую, напр. Лор, Война',
  propose_translation_key_label: 'Ключ перевода',
  propose_translation_key_placeholder: 'Общий ключ, связывающий страницу между языками',
  propose_summary_label: 'Краткое описание',
  propose_summary_placeholder: 'Что изменилось',
  propose_target_page: 'Целевая страница',
  propose_image_label: 'Изображение',
  propose_upload_label: 'Загрузить изображение',
  propose_uploading: 'Загрузка изображения',
  propose_image_hint: 'JPEG, PNG или WebP до 10 MB',
  propose_awaiting: 'Ожидает модерации',
  propose_submitting: 'Отправляем',
  propose_error_login: 'Войдите, чтобы отправить предложение.',
  propose_error_expired: 'Сессия истекла. Войдите снова.',
  propose_error_submit: 'Не удалось отправить предложение.',
  propose_error_upload: 'Не удалось загрузить изображение.',
  // markdown preview
  preview_empty: 'Предпросмотр появится после текста.',
  // moderation
  moderation_title: 'Модерация',
  moderation_no_proposals: 'Нет предложений на модерацию.',
  moderation_queue_title: 'Очередь предложений',
  moderation_moderator_required: 'Нужен вход модератора.',
  moderation_moderator_hint: 'Очередь предложений открыта только редакционной роли.',
  moderation_queue_label: 'Очередь предложений',
  moderation_pending_label: 'Ожидающие',
  moderation_queue_loading: 'Загрузка очереди.',
  moderation_load_more_loading: 'Загрузка',
  moderation_load_more: 'Еще',
  moderation_select: 'Выберите предложение из очереди.',
  moderation_approve_loading: 'Публикуем',
  moderation_approve: 'Одобрить',
  moderation_reject_loading: 'Отклоняем',
  moderation_reject: 'Отклонить',
  moderation_diff_loading: 'Загрузка diff.',
  moderation_back: 'Очередь',
  moderation_forbidden: 'Нет доступа к модерации.',
  moderation_forbidden_hint: 'Требуется роль moderator, superadmin или scope wiki moderation.',
  moderation_error_load: 'Не удалось загрузить очередь модерации.',
  moderation_error_diff: 'Не удалось загрузить diff предложения.',
  moderation_error_load_more: 'Не удалось загрузить следующую страницу.',
  moderation_error_session: 'Сессия истекла. Войдите снова.',
  moderation_error_decision: 'Не удалось сохранить решение.',
  moderation_confirm_approve: 'одобрить',
  moderation_confirm_reject: 'отклонить',
  moderation_confirm: 'Подтвердите: {{action}} предложение "{{label}}"?',
  moderation_approved: 'Одобрено: {{label}}.',
  moderation_approved_revision: ' Ревизия {{id}}.',
  moderation_rejected: 'Отклонено: {{label}}.',
  // categories
  categories_title: 'Категории',
  // page indexes
  page_index_all: 'Все страницы',
  page_index_recent: 'Свежие правки',
  page_index_empty: 'Нет опубликованных страниц.',
  page_index_recent_empty: 'Свежих правок пока нет.',
  page_index_loading: 'Загрузка страниц.',
  page_index_page_count_one: '1 страница',
  page_index_page_count_many: '{{count}} страниц',
  page_index_updated: 'Обновлено {{date}}',
  page_index_stub: 'stub',
  // map
  map_title: 'Карта мира',
  map_loading: 'Загрузка карты.',
  map_canvas_label: 'Карта мира',
  map_canvas_links_label: 'Ссылки на страницы карты мира',
  map_preview_title: 'Карта мира',
  map_preview_link_label: 'Перейти к карте мира',
  map_preview_canvas_label: 'Карта мира — предпросмотр',
  map_filter_label: 'Фильтр по категориям',
  map_filter_all: 'Все',
  // moderation metadata tooltips
  moderation_meta_lang: 'Язык контента',
  moderation_meta_group: 'Группа переводов',
  // moderation proposal kind labels
  moderation_kind_new: 'Новая страница',
  moderation_kind_edit: 'Правка',
  moderation_proposal_label: 'Предложение',
  // markdown preview section heading
  propose_preview_label: 'Предпросмотр',
  // propose field labels
  propose_slug_label: 'Slug',
  propose_markdown_label: 'Markdown',
  // revision history
  history_back: '← Читать',
  history_title: 'История: {{slug}}',
  history_loading_list: 'Загрузка истории.',
  history_no_revisions: 'Нет ревизий.',
  history_not_all: 'Показаны не все ревизии.',
  history_loading_revision: 'Загрузка ревизии.',
  history_old_version: 'Это старая версия страницы.',
  history_compare: 'Сравнить с текущей',
  history_hide_compare: 'Скрыть сравнение',
  history_error_load: 'Не удалось загрузить историю.',
  history_error_revision: 'Не удалось загрузить ревизию.',
  // categories index
  categories_index_kicker: 'Индекс',
  categories_loading: 'Загрузка категорий.',
  categories_empty: 'Пока нет категорий.',
  categories_page_count_one: '1 страница',
  categories_page_count_many: '{{count}} страниц',
  categories_error_load: 'Не удалось загрузить категории.',
  // category view
  category_kicker: 'Категория',
  category_loading: 'Загрузка страниц.',
  category_empty: 'В этой категории пока нет страниц.',
  category_load_more_loading: 'Загрузка…',
  category_load_more: 'Ещё',
  category_error_load: 'Не удалось загрузить категорию.',
  // recent changes feed
  recent_changes_title: 'Свежие правки',
  recent_changes_loading: 'Загрузка свежих правок.',
  recent_changes_empty: 'Правок пока нет.',
  recent_changes_load_more: 'Ещё',
  recent_changes_load_more_loading: 'Загрузка…',
  recent_changes_error_load: 'Не удалось загрузить свежие правки.',
  // reports
  reports_title: 'Отчёты',
  reports_wanted: 'Недостающие страницы',
  reports_orphans: 'Осиротевшие страницы',
  reports_dead_ends: 'Страницы-тупики',
  reports_loading: 'Загрузка отчёта.',
  reports_empty: 'В этом отчёте нет страниц.',
  reports_error_load: 'Не удалось загрузить отчёт.',
  reports_count_one: '1 страница',
  reports_count_many: '{{count}} страниц',
  // site statistics
  nav_stats: 'Статистика',
  stats_title: 'Статистика сайта',
  stats_published_pages: 'Опубликованных страниц',
  stats_stub_pages: 'Заготовок',
  stats_total_revisions: 'Правок всего',
  stats_images: 'Загруженных изображений',
  stats_categories: 'Категорий',
  stats_accounts_by_role: 'Аккаунты по ролям',
  stats_loading: 'Загрузка статистики.',
  stats_error_load: 'Не удалось загрузить статистику.',
  // audit log
  audit_log_title: 'Журнал действий',
  audit_log_loading: 'Загрузка журнала.',
  audit_log_empty: 'Журнал пуст.',
  audit_log_error_load: 'Не удалось загрузить журнал действий.',
  audit_action_proposal_approve: 'Одобрил предложение',
  audit_action_proposal_reject: 'Отклонил предложение',
  audit_action_user_role_change: 'Изменил роль пользователя',
  audit_action_user_scope_change: 'Изменил права пользователя',
  // watchlist
  nav_watchlist: 'Отслеживаемое',
  watch_follow: 'Следить',
  watch_unfollow: 'Не следить',
  watch_loading: 'Обновление…',
  watch_login_required: 'Войдите, чтобы следить за страницами.',
  watchlist_title: 'Отслеживаемые страницы',
  watchlist_empty: 'Вы ещё не следите ни за одной страницей.',
  watchlist_loading: 'Загрузка списка.',
  watchlist_error_load: 'Не удалось загрузить список отслеживаемых страниц.',
  watch_error_follow: 'Не удалось подписаться на страницу.',
  watch_error_unfollow: 'Не удалось отписаться от страницы.',
  // notifications
  notifications_bell_label: 'Уведомления',
  notifications_mark_all_read: 'Отметить все как прочитанные',
  notifications_empty: 'Нет уведомлений.',
  notifications_loading: 'Загрузка уведомлений.',
  notifications_error_load: 'Не удалось загрузить уведомления.',
  notification_kind_proposal_approved: 'Предложение одобрено',
  notification_kind_proposal_rejected: 'Предложение отклонено',
  notification_kind_page_published: 'Страница обновлена',
  // diff
  diff_no_changes: 'Нет отличий от базовой ревизии.',
  // admin user management (superadmin only)
  nav_admin_users: 'Управление пользователями',
  admin_users_title: 'Управление пользователями',
  admin_users_filter_all: 'Все пользователи',
  admin_users_filter_moderators: 'Модераторы',
  admin_users_col_email: 'Email',
  admin_users_col_name: 'Имя',
  admin_users_col_role: 'Роль',
  admin_users_col_created: 'Дата регистрации',
  admin_users_promote: 'Сделать модератором',
  admin_users_demote: 'Снять модератора',
  admin_users_updating: 'Обновление…',
  admin_users_loading: 'Загрузка пользователей.',
  admin_users_error_load: 'Не удалось загрузить пользователей.',
  admin_users_error_update: 'Не удалось обновить роль.',
  admin_users_prev: '← Назад',
  admin_users_next: 'Далее →',
  // errors
  error_load_pages: 'Не удалось загрузить список страниц.',
  error_load_page: 'Не удалось загрузить страницу.',
  error_load_graph: 'Не удалось загрузить связи.',
  error_search: 'Поиск недоступен.',
  error_session_expired: 'Сессия истекла. Войдите снова.',
  error_login_required: 'Требуется вход.',
  error_moderator_required: 'Требуется вход модератора.',
};
